<template>
  <v-container fill-height>
    <v-row justify="center" align="end">
        <v-col cols="12" sm="6">
            <v-card class="elevation-0 transparent" width="567">
                <v-card-title>
                   <h1 id="message-title">Ops!</h1>
                </v-card-title>
                <v-card-text class="text-left white--text py-0">
                    <h1 id="message-text" >{{this.message ? this.message : 'Não conseguimos encontrar a página que você está procurando.'}}</h1>
                    <h2 id="message-status">Código do error: {{this.status ? this.status : '404'}}</h2>
                </v-card-text>
                <v-card-actions class="ma-0 py-0">
                    <v-btn class="ml-2 button-text" height="50" width="180" dark large color="secondary lighten-1" @click="backRoute">
                        Voltar a tela inicial
                    </v-btn> 
                </v-card-actions>
            </v-card>
        </v-col>
        <v-col cols="12" sm="6">
            <v-img height="354" width="449" contain :src="require('@/assets/error-image.svg')"></v-img>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import routes from '../../router/routes';
export default {
    name: 'ResponseError',
    props:['message', 'status'],
    components: {
    },
    data:() => ({
        
    }),
    methods:{
        backRoute(){
            this.$router.push(routes.login.path)
            .catch(()=>{})
        }
    }
}
</script>

<style scoped>
    #message-title{
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;  
        font-size: 96px;
        line-height: 112px;
    }

    #message-text{
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 48px;
        line-height: 56px;
        margin: 24px 0px;
    }

    #message-status{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 20px;
        margin: 24px 0px;
    }

</style>